<template>
  <v-toolbar
    color="white"
    fixed
    class="pl-6 align-center"
    elevation="8"
  >
    <template #prepend>
      <img
        src="@/assets/logo/ochpower.svg"
        width="120"
        class="pointer"
        alt="ochpower logo"
        @click="goLink()"
      >
    </template>
    <v-toolbar-title class="ml-3 align-center text-subtitle-1">
      {{ title }}
    </v-toolbar-title>
    <v-spacer />
  </v-toolbar>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    methods: {
      goLink () {
        let fqdn = location.protocol + '//' + location.host
        location.href = `${fqdn}/login`
      }
    }
  }
</script>
